export default __webpack_public_path__ + "static/media/ico-chart-pie.9dfbb815.svg";